const MAX_SAMPLES_LIMIT = 10;

export function setupProductSamplesPage(form: HTMLFormElement, selectButton: HTMLButtonElement) {
    const sampleInputs = Array.from(form.querySelectorAll<HTMLInputElement>('[name="variations"]'));

    const selectionGroup = new SelectionGroup(sampleInputs);
    const snackbar = new SelectionGroupSnackbar();

    selectButton.disabled = selectionGroup.countSelected() === 0;

    if (selectionGroup.countSelected() === MAX_SAMPLES_LIMIT) {
        selectionGroup.disableUnselected();
    }

    for (const input of sampleInputs) {
        input.addEventListener('oc-property-change', _ => {
            handleSampleClick(selectButton, selectionGroup, snackbar);
        });
    }
}

class SelectionGroupSnackbar {
    private snackbar: HTMLElement;

    constructor() {
        this.snackbar = document.querySelector('#max-samples-reached') as HTMLElement;
    }

    open(limit: number) {
        this.snackbar.setAttribute('message', `Es können maximal ${limit} Muster gewählt werden.`);
        this.snackbar.setAttribute('open', 'true');
    }

    close() {
        this.snackbar.removeAttribute('open');
    }
}

class SelectionGroup {
    constructor(private readonly elements: HTMLInputElement[], private readonly maxSelectable: number = MAX_SAMPLES_LIMIT) {}

    countSelected() {
        return this.elements.filter(element => element.checked).length;
    }

    canSelectMore(): boolean {
        return this.countSelected() < this.maxSelectable;
    }

    selectedIds(): string[] {
        return this.elements.filter(element => element.checked).map(element => element.value);
    }

    enableAll() {
        this.elements.forEach(element => element.removeAttribute('disabled'));
    }

    disableUnselected() {
        return this.elements.filter(element => !element.checked).forEach(element => element.setAttribute('disabled', 'true'));
    }
}

export function updateURL(selectedSamples: string[]) {
    const url = new URL(window.location.href);
    url.searchParams.set('variations', selectedSamples.join(','));
    history.replaceState({}, '', url);
}

export function handleSampleClick(selectButton: HTMLButtonElement, selectionGroup: SelectionGroup, snackbar: SelectionGroupSnackbar) {
    selectButton.disabled = selectionGroup.countSelected() === 0;

    if (selectionGroup.canSelectMore()) {
        snackbar.close();
        selectionGroup.enableAll();
    } else {
        snackbar.open(MAX_SAMPLES_LIMIT);
        selectionGroup.disableUnselected();
    }

    updateURL(selectionGroup.selectedIds());
}
